import React from "react";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
import "./Components/css/common.css";
import "./Components/css/media.css";
import "./Components/css/tabletMedia.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Toaster } from "react-hot-toast";
import { HelmetProvider } from "react-helmet-async";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
      {/* <Toaster position="top-right" />
       */}{" "}
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 3000, // default for all normal toasts
        }}
        containerStyle={{
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          pointerEvents: "none", // important
        }}
      />
    </HelmetProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
